import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { Box } from '@mui/material';
import App from './App';
import { AppThemeProvider } from './theme';
import { AuthProvider } from './auth/AuthContext';
import { store } from './redux/store';
import 'react-flow-renderer/dist/style.css';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <AppThemeProvider>
      <AuthProvider>
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <App />
        </Box>
      </AuthProvider>
    </AppThemeProvider>
  </Provider>
);
